import React from 'react';
import { getTrackBackground, Range } from 'react-range';
import { useTheme } from 'styled-components';

import { StartEndDecorator, Thumb, Track, TrackContainer } from '../DraggableTracks.styles';

const DEFAULT_VALUE = 0;

interface OneThumbDraggableTrackProps {
  step: number;
  min: number;
  max: number;
  value?: number;
  disabled?: boolean;
  onValueChange: (nextValue: number) => void;
}

const OneThumbDraggableTrack = ({ step, min, max, value, disabled, onValueChange }: OneThumbDraggableTrackProps) => {
  // Dependencies
  const theme = useTheme();

  // State
  const [valuesLocal, setValuesLocal] = React.useState([value || DEFAULT_VALUE]);

  // Effects
  React.useEffect(() => {
    if (value && value >= min && value <= max) {
      setValuesLocal([value]);
    }
  }, [value, min, max]);

  return (
    <Range
      values={valuesLocal}
      step={step}
      min={min}
      max={max}
      onChange={(newValues) => {
        setValuesLocal(newValues);
        onValueChange(newValues[0]);
      }}
      disabled={disabled}
      renderTrack={({ props, children }) => (
        <TrackContainer onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart}>
          <StartEndDecorator $start $isOnlyOneThumb />
          <Track
            ref={props.ref}
            style={{
              background: getTrackBackground({
                values: valuesLocal,
                colors: [theme.colors.main.c300, theme.colors.neutrals.c100],
                min,
                max,
              }),
            }}
          >
            {children}
          </Track>
          <StartEndDecorator $isOnlyOneThumb />
        </TrackContainer>
      )}
      renderThumb={({ props }) => <Thumb {...props} />}
    />
  );
};

export default OneThumbDraggableTrack;
